/* eslint-disable */
export default {
  noActiveCalls: 'アクティブな通話はありません',
  noCalls: '結果が見つかりません。',
  currentCall: '現在の通話',
  ringCall: '呼び出し中の通話',
  onHoldCall: '保留中の通話',
  historyCalls: '過去の通話',
  otherDeviceCall: '他のデバイスで進行中の通話',
  searchPlaceholder: '検索...',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No results found."@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"historyCalls"@#@ @source: @#@"Past Calls"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
